module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_003.png
// module id = 948
// module chunks = 0